var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 12,
    fill: "url(#paint0_linear_1706_22718)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5868 13.667H21.4134C16.5601 13.667 13.6667 16.5603 13.6667 21.4137V32.5737C13.6667 37.4403 16.5601 40.3337 21.4134 40.3337H32.5734C37.4268 40.3337 40.3201 37.4403 40.3201 32.587V21.4137C40.3334 16.5603 37.4401 13.667 32.5868 13.667ZM32.0001 32.0003H22.0001C21.4534 32.0003 21.0001 31.547 21.0001 31.0003C21.0001 30.4537 21.4534 30.0003 22.0001 30.0003H32.0001C32.5467 30.0003 33.0001 30.4537 33.0001 31.0003C33.0001 31.547 32.5467 32.0003 32.0001 32.0003ZM32.0001 24.0003H22.0001C21.4534 24.0003 21.0001 23.547 21.0001 23.0003C21.0001 22.4537 21.4534 22.0003 22.0001 22.0003H32.0001C32.5467 22.0003 33.0001 22.4537 33.0001 23.0003C33.0001 23.547 32.5467 24.0003 32.0001 24.0003Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1706_22718",
    x1: 27,
    y1: 0,
    x2: 27,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCA59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC9201"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFilled);
export default __webpack_public_path__ + "static/media/newFilled.92c5f0738ab7c06633a14ed3c76b7759.svg";
export { ForwardRef as ReactComponent };